import { Button } from '@marketplace/ui-elements';
import { useIntl } from 'react-intl';
import classes from './card.module.scss';

type TCardProps = {
  icon: any;
  title: string;
  description: string;
  color: 'pink' | 'green' | 'purple';
};

export const Card = ({ icon, title, description, color }: TCardProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className={classes.root}>
      <img src={icon} alt="" />
      <div className={classes.title}>{title}</div>
      <div className={classes.cardDescription}>{description}</div>
      <Button rootClassName={classes[color]} variant="custom">
        {formatMessage({
          id: 'developer_card_button_capitalized',
        })}
      </Button>
    </div>
  );
};
